import { useMutation } from '@tanstack/react-query';
import {
  getLanguage,
  InviteInterpreter,
  getStatus,
  SaveVoyceId,
  InterpreterHistory,
} from '../services/interpreterService';
import type {
  LanguageLsitType,
  InviteInterpreterType,
  InterpreterHistoryProps,
} from '../services/interpreterService';
export interface LanguageListResponse {
  status: string;
  message: string;
  data: LanguageLsitType;
}
export const useGetLanguage = () => {
  return useMutation({
    mutationFn: async () => {
      const data = await getLanguage();
      return data;
    },
  });
};

export const useGetStatus = () => {
  return useMutation({
    mutationFn: async (voyceId: string) => {
      const data = await getStatus(voyceId);
      return data;
    },
  });
};

export const useInviteInterpreter = () => {
  return useMutation({
    mutationFn: async (voycedata: InviteInterpreterType) => {
      const data = await InviteInterpreter(voycedata);
      return data;
    },
  });
};

export const useSaveVoyceId = () => {
  return useMutation({
    mutationFn: async (saveData: {
      voyceId: number;
      caseId: number;
      userId: number;
    }) => {
      const data = await SaveVoyceId(saveData);
      return data;
    },
  });
};

export const useUpdateInterpreterHistory = (userId: number) => {
  return useMutation<InterpreterHistoryProps, Error, InterpreterHistoryProps>({
    mutationFn: async (payload) => {
      const data = await InterpreterHistory(userId, payload);
      return data;
    },
  });
};
